module.exports = __webpack_public_path__ + "static/media/10-6.dc4dfd63.mp3";